import { render, staticRenderFns } from "./ConvertProduct.vue?vue&type=template&id=2d124f50&scoped=true&"
import script from "./ConvertProduct.vue?vue&type=script&lang=js&"
export * from "./ConvertProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d124f50",
  null
  
)

export default component.exports